import axios from '@axios';
import { reject } from 'lodash';

export default {
    namespaced: true,
    state: {
        segmentacion_cartera: [],
        categoria_cliente: [],
        cuentas:[],
        tipos_cliente: [],
        tipos: [],
        subtipos: [],
        zonas: [],
        presupuesto: [],
        divisiones: [],
        bodegas: [],
        vendedores: [],
        formasPago: [],
    },
    getters: {
        getSegmentacion(state) {
            return state.cartera
        },
        getCategoriaCliente(state) {
            return state.categoria_cliente
        },
        getCuentas(state) {
            return state.cuentas
        },
        getTipoCliente(state) {
            return state.tipos_cliente
        },
        getTipo(state) {
            return state.tipos
        },
        getSubtipo(state) {
            return state.subtipos
        },
        getZona(state) {
            return state.zonas
        },
        getPresupuesto(state) {
            return state.presupuesto
        },
        getDivision(state) {
            return state.divisiones
        },
        getBodega(state) {
            return state.bodegas
        },
        getVendedores(state){
            return state.vendedores
        },
        getFormaPago(state){
            return state.formasPago
        }
    },
    mutations: {
        setSegmentacion(state, cartera) {
            state.cartera = cartera
        },
        setCategoriaCliente(state, categoria_cliente) {
            state.categoria_cliente = categoria_cliente
        },
        setCuentas(state, cuentas) {
            state.cuentas = cuentas
        },
        setTipoCliente(state, tipos_cliente) {
            state.tipos_cliente = tipos_cliente
        },
        setTipo(state, tipos) {
            state.tipos = tipos
        },
        setSubtipo(state, subtipos) {
            state.subtipos = subtipos
        },
        setZona(state, zonas) {
            state.zonas = zonas
        },
        setPresupuesto(state, presupuesto) {
            state.presupuesto = presupuesto
        },
        setDivision(state, divisiones) {
            state.divisiones = divisiones
        },
        setBodega(state, bodegas) {
            state.bodegas = bodegas
        },
        setVendedor(state, vendedores) {
            state.vendedores = vendedores
        },
        setFormaPago(state, formasPago) {
            state.formasPago = formasPago
        }
    },
    actions: {
        fetchCartera({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/segmentacionCartera/carterasPG')
                    .then((response) => {
                        commit('setSegmentacion', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchCategoriaCliente({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/categoriasClientePG/')
                    .then((response) => {
                        commit('setCategoriaCliente', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchCuentas({ commit }, idCategoria) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/categoriasClientePG/' + idCategoria)
                    .then((response) => {
                        commit('setCuentas', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTipoCliente({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/tiposClientePG')
                    .then((response) => {
                        commit('setTipoCliente', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchTipo({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/tipoPG')
                    .then((response) => {
                        commit('setTipo', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchSubtipo({ commit }, idTipo) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/subtipoPG/' + idTipo)
                    .then((response) => {
                        commit('setSubtipo', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchZona({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/zonaPG')
                    .then((response) => {
                        commit('setZona', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchPresupuesto({ commit }, idZona) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/zonaPG/' + idZona)
                    .then((response) => {
                        commit('setPresupuesto', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchDivision({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/divisionPG')
                    .then((response) => {
                        commit('setDivision', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchBodega({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/bodegaPG')
                    .then((response) => {
                        commit('setBodega', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchVendedor({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/vendedorPG')
                    .then((response) => {
                        commit('setVendedor', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchFormaPago({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/personas/formaPagoPG')
                    .then((response) => {
                        commit('setFormaPago', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        }
    }
}